// F-AUTH-07, F-STV-11 — geç yanıtlar ve sekmeler arası çerez değişimi eski hesabı yeniden açmamalı.
export class OturumDegistiHatasi extends Error {
  constructor() {
    super("Oturumunuz değişti. Lütfen yeniden giriş yapınız.");
  }
}

export class OturumYonetimi {
  nesil = 0;
  kullaniciId: string | null = null;
  kapali = false;
  private kimlik: string | undefined;
  private gorunumKimligi: string | undefined;
  private dinleyiciler = new Set<() => void>();
  private istekler = new Set<AbortController>();
  private kanal: BroadcastChannel | null = null;
  private sonBildirim: string | null = null;
  private readonly bildirimAnahtari = "koclukpanel-oturum-degisimi";

  constructor() {
    try {
      this.kapali = sessionStorage.getItem("oturum-kapali") === "evet";
      this.sonBildirim = localStorage.getItem(this.bildirimAnahtari);
    } catch {
      /* F-AUTH-07 — saklama kapalıysa sunucu kimliği yeniden doğrular. */
    }
  }

  dinle = (dinleyici: () => void): (() => void) => {
    this.dinleyiciler.add(dinleyici);
    return () => {
      this.dinleyiciler.delete(dinleyici);
    };
  };
  goruntu = (): number => this.nesil;

  degistir(kapali: boolean, yayinla = true): void {
    this.kapali = kapali;
    try {
      sessionStorage.setItem("oturum-kapali", kapali ? "evet" : "hayir");
    } catch {
      /* Açık sekmedeki sınır korunur. */
    }
    this.kimlik = undefined;
    this.gorunumKimligi = undefined;
    this.kullaniciId = null;
    this.nesil += 1;
    for (const istek of this.istekler) istek.abort();
    this.istekler.clear();
    for (const dinleyici of this.dinleyiciler) dinleyici();
    if (yayinla) {
      const bildirim = JSON.stringify({ kapali, kimlik: crypto.randomUUID() });
      this.sonBildirim = bildirim;
      try {
        localStorage.setItem(this.bildirimAnahtari, bildirim);
      } catch {
        /* Depolama kapalıysa açık sekmeler kanaldan haber alır. */
      }
      this.kanal?.postMessage(bildirim);
    }
  }

  dogrula(veri: { girisYapildi: boolean; userId: string | null }): void {
    const kimlik = veri.girisYapildi ? (veri.userId ?? "") : "";
    if (this.kimlik !== undefined && this.kimlik !== kimlik) this.degistir(!veri.girisYapildi);
    this.kimlik = kimlik;
    this.kullaniciId = veri.girisYapildi ? veri.userId : null;
  }

  gorunumuDogrula(veri: { aktif: boolean; gorunumId?: string }): void {
    const kimlik = veri.aktif ? (veri.gorunumId ?? "") : "";
    if (this.gorunumKimligi !== undefined && this.gorunumKimligi !== kimlik) this.degistir(false);
    this.gorunumKimligi = kimlik;
  }

  istekBaslat(): {
    nesil: number;
    denetleyici: AbortController;
    bitir: () => void;
    dogrula: () => void;
  } {
    const nesil = this.nesil;
    const denetleyici = new AbortController();
    this.istekler.add(denetleyici);
    return {
      nesil,
      denetleyici,
      bitir: () => {
        this.istekler.delete(denetleyici);
      },
      dogrula: () => {
        if (nesil !== this.nesil || denetleyici.signal.aborted) throw new OturumDegistiHatasi();
      },
    };
  }

  sekmeleriDinle(): () => void {
    const al = (bildirim: unknown) => {
      if (typeof bildirim !== "string" || bildirim === this.sonBildirim) return;
      try {
        const veri = JSON.parse(bildirim) as { kapali?: unknown };
        if (typeof veri.kapali !== "boolean") return;
        this.sonBildirim = bildirim;
        this.degistir(veri.kapali, false);
      } catch {
        /* F-AUTH-07 — bozuk bir bildirim hesap kimliği olarak kullanılamaz. */
      }
    };
    const depolama = (olay: StorageEvent) => {
      if (olay.key === this.bildirimAnahtari) al(olay.newValue);
    };
    const odak = () => {
      try {
        al(localStorage.getItem(this.bildirimAnahtari));
      } catch {
        /* Özel tarayıcı kipinde depolama kapalı olabilir. */
      }
    };
    odak();
    if (typeof BroadcastChannel !== "undefined") {
      this.kanal = new BroadcastChannel(this.bildirimAnahtari);
      this.kanal.onmessage = (olay: MessageEvent<unknown>) => al(olay.data);
    }
    window.addEventListener("storage", depolama);
    window.addEventListener("focus", odak);
    return () => {
      this.kanal?.close();
      this.kanal = null;
      window.removeEventListener("storage", depolama);
      window.removeEventListener("focus", odak);
    };
  }
}

export const oturum = new OturumYonetimi();
